import type { DropDownMultiSelectProps } from '@myosh/odin-components';
import { DropDownMultiSelect, OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';

interface HfDropDownMultiSelectProps extends DropDownMultiSelectProps {
  control: Control;
  name: string;
}

export default function HfDropDownMultiSelect(props: HfDropDownMultiSelectProps) {
  const {
    control,
    name,
    id,
    textField,
    valueField,
    label,
    value,
    data,
    allowClear,
    allowSearch,
    preloadData = false,
    multipleMessageCount,
    multipleMessageText,
    useChips,
    placeholder,
    filterLocation,
    actionItems,
    onActionItemChanged,
    readOnly,
    required,
    className,
    containerStyles,
    labelStyles,
    dropDownStyles,
    dropDownIconSize,
    dropDownButtonStyles,
    clearButtonStyles,
    onDoubleClick,
    onChange,
    fieldValueConverter,
    disabled,
    shouldUseCreatePortal,
  } = props;

  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <DropDownMultiSelect
            id={id || 0}
            textField={textField}
            valueField={valueField}
            label={label}
            value={value}
            data={data}
            error={error?.message}
            allowClear={allowClear}
            allowSearch={allowSearch}
            preloadData={preloadData}
            multipleMessageCount={multipleMessageCount}
            multipleMessageText={multipleMessageText}
            useChips={useChips}
            placeholder={placeholder}
            filterLocation={filterLocation}
            actionItems={actionItems}
            onActionItemChanged={onActionItemChanged}
            readOnly={readOnly}
            required={required}
            onChange={onChange}
            className={className}
            containerStyles={containerStyles}
            labelStyles={labelStyles}
            dropDownStyles={dropDownStyles}
            dropDownIconSize={dropDownIconSize}
            dropDownButtonStyles={dropDownButtonStyles}
            clearButtonStyles={clearButtonStyles}
            onDoubleClick={onDoubleClick}
            disabled={disabled}
            shouldUseCreatePortal={shouldUseCreatePortal}
          />
        );
      }}
    />
  );
}
